import React from 'react';
import { TRAVEL_BUDGET_OPTIONS, TRAVEL_GENDER_OPTIONS } from '../../utils/travelPostLabels';
import { SECTION_THEME } from '../../utils/sectionTheme';

const chipStyle = (isSelected) => ({
  minHeight: '44px',
  padding: '7px 12px',
  color: isSelected ? '#ffffff' : '#526579',
  background: isSelected ? SECTION_THEME.travel.accent : '#f8fafc',
  border: isSelected ? `1px solid ${SECTION_THEME.travel.accent}` : '1px solid #dbe4ee',
  borderRadius: '999px',
  fontFamily: 'inherit',
  fontSize: '12px',
  fontWeight: '750',
  cursor: 'pointer'
});

const fieldStyle = {
  boxSizing: 'border-box',
  width: '100%',
  minHeight: '44px',
  padding: '9px 11px',
  color: '#334155',
  background: '#f8fafc',
  border: '1px solid #dbe4ee',
  borderRadius: '12px',
  fontFamily: 'inherit',
  fontSize: '13px'
};

const sectionLabelStyle = {
  marginBottom: '8px',
  color: '#526579',
  fontSize: '12px',
  fontWeight: '750'
};

export default function TravelFilterPanel({
  availableCountries,
  countryFilter,
  updateCountryFilter,
  genderFilter,
  setGenderFilter,
  budgetFilters,
  toggleBudgetFilter,
  dateStartFilter,
  setDateStartFilter,
  dateEndFilter,
  setDateEndFilter,
  activeFilterCount,
  searchQuery,
  onClear,
  variant = 'inline'
}) {
  const isDrawer = variant === 'drawer';
  return (
    <div data-filter-panel="travel" data-variant={variant} style={{ marginBottom: isDrawer ? 0 : '16px', padding: isDrawer ? 0 : '15px', background: isDrawer ? 'transparent' : 'rgba(255,255,255,0.92)', border: isDrawer ? 'none' : '1px solid rgba(207,222,235,0.9)', borderRadius: isDrawer ? 0 : '18px', boxShadow: isDrawer ? 'none' : '0 10px 28px rgba(15,23,42,0.07)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: isDrawer ? 'flex-end' : 'space-between', gap: '12px', marginBottom: '12px' }}>
        {!isDrawer && <span style={{ color: '#334155', fontSize: '13px', fontWeight: '800' }}>篩選條件</span>}
        {(activeFilterCount > 0 || searchQuery) && <button type="button" onClick={onClear} style={{ minHeight: '44px', padding: '6px 8px', color: SECTION_THEME.travel.accent, background: 'transparent', border: 'none', fontFamily: 'inherit', fontSize: '12px', fontWeight: '800', cursor: 'pointer' }}>清除全部</button>}
      </div>

      <div style={{ display: 'grid', gap: '20px' }}>
        <section aria-labelledby="travel-country-filter-label">
          <div id="travel-country-filter-label" style={sectionLabelStyle}>旅行國家</div>
          {availableCountries.length === 0 ? (
            <p style={{ margin: 0, color: '#94a3b8', fontSize: '12px' }}>目前沒有可篩選的國家。</p>
          ) : (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {availableCountries.map(country => {
                const isSelected = countryFilter.includes(country);
                return <button key={country} type="button" aria-pressed={isSelected} onClick={() => updateCountryFilter(country)} style={chipStyle(isSelected)}>{country}</button>;
              })}
            </div>
          )}
        </section>

        <section aria-labelledby="travel-gender-filter-label">
          <div id="travel-gender-filter-label" style={sectionLabelStyle}>旅伴性別</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {[{ value: '', label: '全部性別' }, ...TRAVEL_GENDER_OPTIONS].map(option => {
              const isSelected = genderFilter === option.value;
              return <button key={option.value || 'all'} type="button" aria-pressed={isSelected} onClick={() => setGenderFilter(option.value)} style={chipStyle(isSelected)}>{option.label}</button>;
            })}
          </div>
        </section>

        <section aria-labelledby="travel-budget-filter-label">
          <div id="travel-budget-filter-label" style={sectionLabelStyle}>旅行預算</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {TRAVEL_BUDGET_OPTIONS.map(option => {
              const isSelected = budgetFilters.includes(option.value);
              return <button key={option.value} type="button" aria-pressed={isSelected} onClick={() => toggleBudgetFilter(option.value)} style={chipStyle(isSelected)}>{option.label}</button>;
            })}
          </div>
        </section>

        <section aria-labelledby="travel-date-filter-label">
          <div id="travel-date-filter-label" style={sectionLabelStyle}>旅行日期區間</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: '10px' }}>
            <label htmlFor="travel-drawer-filter-start" style={{ display: 'grid', gap: '6px', color: '#526579', fontSize: '11px', fontWeight: '700' }}>
              開始日期
              <input id="travel-drawer-filter-start" type="date" aria-label="篩選開始日期" value={dateStartFilter} max={dateEndFilter || undefined} onChange={event => setDateStartFilter(event.target.value)} style={fieldStyle} />
            </label>
            <label htmlFor="travel-drawer-filter-end" style={{ display: 'grid', gap: '6px', color: '#526579', fontSize: '11px', fontWeight: '700' }}>
              結束日期
              <input id="travel-drawer-filter-end" type="date" aria-label="篩選結束日期" value={dateEndFilter} min={dateStartFilter || undefined} onChange={event => setDateEndFilter(event.target.value)} style={fieldStyle} />
            </label>
          </div>
        </section>
      </div>
    </div>
  );
}
